import React, { useEffect, useState } from "react";
import PageWrapper from "../SignupPages/PageWrapper";
import { v4 as uuidv4 } from "uuid";
import SemaglutideOrgBottle from "../../assets/images/claya-semaglutide-vial-2-og.png";
import OralSemaglutideImg from "../../assets/images/OralSemaglutideImg.png";
import OralTirzepatideImg from "../../assets/images//OralTirzepatideImg.png";
import TirezepatideBottle from "../../assets/images/claya-tirzepatide-vial-2.png";
import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import OnlineIcon from "../../assets/images/online.png";
import { useLocation, useNavigate } from "react-router-dom";
import "./CheckoutSignupPages.css";

const CheckoutSignupPage1: React.FC = () => {
  const [selectedType, setSelectedType] = useState<"Injectable" | "Oral">(
    "Injectable"
  );
  const [selectedMed, setSelectedMed] = useState<string>("Semaglutide");
  const navigate = useNavigate();
  const location = useLocation();

  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

useEffect(() => {
  const newUUID = uuidv4();
  localStorage.setItem(
    "uuid",
    JSON.stringify({ key: "uuid", value: newUUID })
  );
}, []);

  const handleTabChange = (type: "Injectable" | "Oral") => {
    setSelectedType(type);
    if (type === "Oral") {
      setSelectedMed("Semaglutide");
    } else if (type === "Injectable") {
      setSelectedMed("Semaglutide");
    }
  };

  const handleMedSelect = (med: string): void => {
    setSelectedMed(med);
  };

  const medications = {
    Injectable: [
      {
        id: "Semaglutide",
        name: "Semaglutide",
        img: SemaglutideOrgBottle,
        desc: "Same active ingredient as Ozempic® and Wegovy®",
        tag: "Most Popular",
        oldPrice: 247,
        newPrice: 147,
      },
      {
        id: "Tirzepatide",
        name: "Tirzepatide",
        img: TirezepatideBottle,
        desc: "Same active ingredient as Mounjaro® and Zepbound®",
        tag: "Most Effective",
        oldPrice: 349,
        newPrice: 249,
      },
    ],
    Oral: [
      {
        id: "Semaglutide",
        name: "Semaglutide",
        img: OralSemaglutideImg,
        desc: "Same active ingredient as Ozempic® and Wegovy®",
        tag: "Most Popular",
        oldPrice: 245,
        newPrice: 145,
      },
      {
        id: "Tirzepatide",
        name: "Tirzepatide",
        img: OralTirzepatideImg,
        desc: "Same active ingredient as Mounjaro® and Zepbound®",
        tag: "Most Effective",
        oldPrice: 346,
        newPrice: 246,
      },
    ],
  };

  const medCardOptions = () => {
    const currentMeds = medications[selectedType];

    return (
      <div className="med-card-container med-card-container-box">
        {currentMeds.map((med) => {
          return (
            <div
              key={med.id}
              className={`med-card med-card-box ${
                selectedMed === med.name ? "med-selected med-selected-box" : ""
              }`}
              onClick={() => handleMedSelect(med.name)}
            >
              {/* Custom Radio Button */}
              <div className="custom-radio-container">
                <div
                  className={`custom-radio-outer ${
                    selectedMed === med.name ? "selected" : ""
                  }`}
                >
                  {selectedMed === med.name && (
                    <div className="custom-radio-inner" />
                  )}
                </div>
              </div>
              <div
                className={`med-label ${
                  med.id === "Semaglutide" ? "semaglutide" : "tirzepatide"
                }`}
              >
                {med.tag}
              </div>
              <div className="med-info-card med-info-card-box">
                <img
                  src={med.img}
                  alt={`${med.name}-${selectedType}`}
                  className="med-img"
                />
                <div className="med-details med-details-box">
                  <h3
                    className={`med-name med-name-text ${
                      selectedMed === med.name ? "med-name-box" : ""
                    }`}
                  >{`${med.name}`}</h3>
                  <p
                    className={`med-description med-description-text ${
                      selectedMed === med.name ? "med-description-box" : ""
                    }`}
                  >
                    {med.desc}
                  </p>
                  <div className="med-stock med-stock-box">
                    <div className="med-stock-content">
                      <img
                        src={OnlineIcon}
                        alt="In Stock"
                        className="med-stock-icon med-stock-icon-box"
                      />
                      <span
                        className={`med-stock-label med-stock-text ${
                          selectedMed === med.name ? "med-stock-label-box" : ""
                        }`}
                      >
                        In-Stock
                      </span>
                    </div>

                    <div
                      className="med-price-content"
                    >
                      <span className="med-old-price">${med.oldPrice}</span>
                      <div className="med-new-price-content">
                        <span
                          className={`med-starts-from ${
                            selectedMed === med.name
                              ? "med-starts-from-box"
                              : ""
                          }`}
                        >
                          starts from
                        </span>
                        <span
                          className={`med-new-price ${
                            selectedMed === med.name ? "med-new-price-box" : ""
                          }`}
                        >
                          ${med.newPrice}/mo
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="coupon-badge">
                  $100 OFF 1st MONTH
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleNext = () => {
    localStorage.setItem("selectedMed", selectedMed);
    localStorage.setItem("selectedType", selectedType);
    safeNavigate("/glp1/checkout/payment");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container page-checkout-container">
        <div className="checkout-container">
          <div className="checkout-med-container">
            {/* <span className="med-contianer-heading med-contianer-heading-box" >
              1. Choose your medication
            </span>
            <div className="tabs-container tabs-container-box">
              <button
                className={`tab-button tab-button-box ${
                  selectedType === "Injectable"
                    ? "selected tab-button-selected"
                    : ""
                }`}
                onClick={() => handleTabChange("Injectable")}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3322 0.159478L11.0822 0.909538L11.8323 1.6596C12.0526 1.87993 12.0526 2.23621 11.8323 2.45419C11.612 2.67218 11.2557 2.67452 11.0377 2.45419L10.6861 2.1026L9.79072 2.99564L11.0799 4.28481C11.3002 4.50514 11.3002 4.86142 11.0799 5.0794C10.8596 5.29739 10.5033 5.29973 10.2853 5.0794L8.59766 3.39177L6.91002 1.70648C6.68969 1.48615 6.68969 1.12987 6.91002 0.911882C7.13035 0.693895 7.48663 0.691552 7.70461 0.911882L8.99378 2.20105L9.88916 1.30801L9.53523 0.956417C9.3149 0.736086 9.3149 0.379808 9.53523 0.161822C9.75556 -0.0561646 10.1118 -0.0585086 10.3298 0.161822L10.3322 0.159478ZM4.9247 3.64491L6.35685 2.21277C6.36388 2.2198 6.37091 2.22918 6.38029 2.23621L6.75532 2.61124L8.06793 3.92384L9.38053 5.23645L9.75556 5.61148C9.76259 5.61851 9.76962 5.62554 9.779 5.63492L5.30208 10.1118C5.05596 10.358 4.72313 10.4962 4.37388 10.4962H2.29246L0.956417 11.8323C0.736086 12.0526 0.379808 12.0526 0.161822 11.8323C-0.0561646 11.612 -0.0585086 11.2557 0.161822 11.0377L1.49787 9.70165V7.62023C1.49787 7.27099 1.63616 6.93815 1.88227 6.69203L2.8972 5.67711L4.23324 7.01315C4.37857 7.15848 4.61765 7.15848 4.76297 7.01315C4.9083 6.86783 4.9083 6.62875 4.76297 6.48342L3.42693 5.14738L4.39732 4.17699L5.73336 5.51303C5.87869 5.65836 6.11777 5.65836 6.26309 5.51303C6.40842 5.36771 6.40842 5.12863 6.26309 4.9833L4.92705 3.64726L4.9247 3.64491Z"
                    fill={`${
                      selectedType === "Injectable" ? "#FFFFFF" : "#CCCCCC"
                    }`}
                  />
                </svg>
                Injectable
              </button>
              <button
                className={`tab-button tab-button-box ${
                  selectedType === "Oral" ? "selected tab-button-selected" : ""
                }`}
                onClick={() => handleTabChange("Oral")}
              >
                <svg
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.7566 5.78906C14.6341 5.97422 14.375 5.98828 14.2172 5.83125L9.50164 1.13906C9.34383 0.982031 9.3556 0.721875 9.54404 0.602344C10.1352 0.220313 10.8372 0 11.5932 0C13.6754 0 15.3619 1.67812 15.3619 3.75C15.3619 4.50234 15.1405 5.20078 14.7566 5.78906ZM13.6425 6.89766C13.0536 7.27969 12.3493 7.5 11.5932 7.5C9.51106 7.5 7.82458 5.82188 7.82458 3.75C7.82458 2.99766 8.04599 2.29922 8.42992 1.71094C8.55241 1.52578 8.8115 1.51172 8.96931 1.66875L13.6849 6.36094C13.8427 6.51797 13.8309 6.77812 13.6425 6.89766ZM7.38883 8.625C7.61259 8.625 7.7869 8.81719 7.74214 9.03516C7.37941 10.7297 5.86723 12 4.05592 12C2.2446 12 0.732422 10.7297 0.369688 9.03516C0.32258 8.81719 0.499236 8.625 0.723001 8.625H7.38883ZM7.38883 7.875H0.723001C0.499236 7.875 0.324935 7.68281 0.369688 7.46484C0.732422 5.77031 2.2446 4.5 4.05592 4.5C5.86723 4.5 7.37941 5.77031 7.74214 7.46484C7.78925 7.68281 7.61259 7.875 7.38883 7.875Z"
                    fill={`${selectedType === "Oral" ? "#FFFFFF" : "#CCCCCC"}`}
                  />
                </svg>
                Oral tablets
              </button>
            </div>
            <p className="tabs-subtext-content">
              <span className="tabs-subtext-injectable-content">
                Once a week
              </span>
              <span className="tabs-subtext-oral-content">Once daily </span>
            </p> */}
            <span className="med-contianer-heading med-contianer-heading-content med-contianer-heading-box">
              Choose your GLP-1
            </span>
            {medCardOptions()}
          </div>
        </div>

        <button className="next-btn" onClick={handleNext}>
          Proceed to Checkout
        </button>
      </div>
    </PageWrapper>
  );
};

export default CheckoutSignupPage1;
